import ButtonSkeleton from '@/components/skeletons/Button'
import { useModal } from '@/contexts/modal'
import UploadIcons from '@/icons/UploadIcons'
import { ScannerContractModalProps } from '@/modals/ContractModals/ScannerContractModal'
import { getContractCustomer } from '@/modules/Contract/services/customer'
import { ContractStatus } from '@/modules/Contract/types'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Button } from 'vnetwork-ui'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Scanner = () => {
    const { t } = useTranslation()
    const { contractID } = useParams<{ contractID: string }>()
    const { setModal } = useModal()
    const {
        data: contract,
        isLoading,
        renderState,
    } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.CONTRACT_DETAIL, contractID || ''],
            queryFn: () =>
                getContractCustomer({ contractID: Number(contractID) }),
            enabled: !!contractID,
        },
        {
            loadingComponent: <ButtonSkeleton width={242} />,
        }
    )

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <Button
            size="small"
            variant="contained"
            startIcon={<UploadIcons />}
            disabled={
                contract?.result?.contract_status === ContractStatus.Outdate
            }
            loading={isLoading}
            onClick={() => {
                setModal<ScannerContractModalProps>(
                    'ContractModals/ScannerContractModal/index',
                    {
                        contractID: Number(contractID),
                    }
                )
            }}
        >
            {t('contracts.customer.scanner')}
        </Button>
    )
}

export default Scanner
